/* =============================================================
   BLUEMINGS PRE-LAUNCH — Page-scoped JS
   - Nav scroll-blur effect
   - Newsletter session-state handling
   ============================================================= */

(function () {
  'use strict';

  document.documentElement.classList.add('js-loaded');

  // ============================================================
  // NAV SCROLL-TRIGGERED BLUR
  // Adds .is-scrolled to .bm-nav when user scrolls past 40px.
  // ============================================================
  var nav = document.querySelector('.bm-nav');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 40) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ============================================================
  // NEWSLETTER FORM — SHOPIFY-CONFIRMED SESSION STATE
  // The form submits natively to Shopify. Only Shopify's server-rendered
  // posted_successfully state is persisted for the current browser-tab session.
  // ============================================================
  var newsletterStorageKey = 'bluemings_newsletter_subscribed';
  var forms = document.querySelectorAll('form[data-bm-newsletter]');

  function readSubscribedSession() {
    try {
      return window.sessionStorage.getItem(newsletterStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function writeSubscribedSession() {
    try {
      window.sessionStorage.setItem(newsletterStorageKey, 'true');
    } catch (error) {
      // The Shopify-confirmed success remains visible even if storage is blocked.
    }
  }

  function showConfirmedSuccess(form) {
    var formRow = form.querySelector('[data-bm-form-row]');
    var microcopy = form.querySelector('[data-bm-form-microcopy]');
    var successEl = form.querySelector('[data-bm-form-success]');
    var errorEl = form.querySelector('[data-bm-form-error]');

    if (formRow) formRow.hidden = true;
    if (microcopy) microcopy.hidden = true;
    if (successEl) successEl.hidden = false;
    if (errorEl) errorEl.hidden = true;
  }

  var shopifyConfirmed = Array.prototype.some.call(forms, function (form) {
    var successEl = form.querySelector('[data-bm-form-confirmed="true"]');
    return Boolean(successEl);
  });

  if (shopifyConfirmed) {
    writeSubscribedSession();
  }

  if (shopifyConfirmed || readSubscribedSession()) {
    forms.forEach(showConfirmedSuccess);
  } else {
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var submitBtn = form.querySelector('button[type="submit"]');

        // Do not set session state here: Shopify has not confirmed success yet.
        // Native browser validation runs first; valid forms then post to Shopify.
        if (submitBtn && form.checkValidity()) {
          submitBtn.disabled = true;
          submitBtn.style.opacity = '0.5';
        }
      });
    });
  }

  // ============================================================
  // MOODBOARD MARQUEE — drift, but let a hand override it
  // The rail scrolls natively at every width. While someone is touching or
  // scrolling it the drift pauses, so the swipe is the only thing moving;
  // it picks back up a beat after they let go. Hover already pauses it in CSS.
  // ============================================================
  document.querySelectorAll('.bm-marquee').forEach(function (rail) {
    var releaseTimer = null;

    function hold() {
      if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = null; }
      rail.classList.add('is-held');
    }
    function release(delay) {
      if (releaseTimer) clearTimeout(releaseTimer);
      releaseTimer = setTimeout(function () { rail.classList.remove('is-held'); }, delay);
    }

    rail.addEventListener('pointerdown', hold, { passive: true });
    rail.addEventListener('touchstart', hold, { passive: true });
    rail.addEventListener('scroll', function () { hold(); release(2000); }, { passive: true });

    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (evt) {
      rail.addEventListener(evt, function () { release(2000); }, { passive: true });
    });
  });

  // ============================================================
  // FADE-IN ON SCROLL — DISABLED (per user request)
  // ============================================================
  /*
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.bm-prelaunch section').forEach(function (s) {
      s.classList.add('bm-reveal');
      observer.observe(s);
    });
  }
  */
})();
